import React, { Component } from 'react';
import styled from 'styled-components';
import teamData from '../data/team';
import imageMail from '../assets/images/mail.png';
import imageLinkedin from '../assets/images/linkedin.svg';
import media from '../styles/media';

class Team extends Component {
  render() {
    return (
      <Root id="Team">
        <Content>
          <h4>The Team</h4>
          <h2>Leading by example</h2>
          <p>
            Two fathers, and two sons – we are a family business built on the
            experience and expertise of two generations. Our values come from
            our founders, and their philosophy of hard work and dedication to
            craftsmanship has not only been passed onto generation to the next,
            it is a foundation that everyone on our team follows in everything
            we do.
          </p>
        </Content>
      </Root>
    );
  }
}

export default Team;

const Content = styled.div`
  @media (min-width: ${media.md}) {
    width: 525px;
  }
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  width: 260px;
  justify-content: space-between;
`;

const MailImage = styled.img`
  height: 17px;
  width: 24px;
`;

const Root = styled.div`
  @media (min-width: ${media.md}) {
    background-image: url('/assets/images/leading-background.jpg');
    background-size: contain;
    height: 900px;
    padding-top: 161px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  background-image: url('/assets/images/leading-background.jpg');
  background-size: cover;
  background-position: center;
  height: 830px;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 61px;
  h2 {
    margin-bottom: 25px;
  }
  h4 {
    color: white;
  }
  p {
    color: #ffffff;
  }
`;

const Teams = styled.div`
  @media (min-width: ${media.md}) {
    width: 650px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 65px;
    margin-left: 130px;
  }

  position: relative;
  padding-left: 20px;
  ul {
    position: relative;
    margin-top: 30px;
    &:before {
      content: '';
      width: 100%;
      border-left: solid 3px #f87642;
      height: 50px;
      position: absolute;
      left: -20px;
      z-index: 1;
    }
  }
  h2 {
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0.4px;
    margin-bottom: 3px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Team.js